import React, { Fragment } from 'react';

export const ErrorMessage = ({ errorMessages }: { errorMessages: string[] }) => {
	if (!errorMessages.length) {
		return null;
	}

	return (
		<>
			{errorMessages.map((message, index) => (
				<Fragment key={index}>
					{message}
					<br />
				</Fragment>
			))}
		</>
	);
};
